import { useState } from "react";
import { Box, Text, VStack, Select, Grid, GridItem, Divider } from "@chakra-ui/react";
import background from "../assets/bg.jpg";
import Menubar from "../components/Menubar";
import { ACCENT_1_COLOR, PRIMARY_COLOR } from "../constants/color";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

export default function Equipment() {
  // Data Perlengkapan Latihan
  const {t} = useTranslation();
  const equipmentData = {
    "1": {
      name: "Bokuto Bengkirai (+ Tsuba)",
      price: "Rp 190.000",
      description: t("equipmentDesc9.7")
    },
    "2": {
      name: "Bokuto Ulin Kalimantan (+ Tsuba)",
      price: "Rp 400.000",
      description: t("equipmentDesc9.8")
    },
    "3": {
      name: "Kaku Obi",
      price: "Rp 115.000",
      description: t("equipmentDesc9.6")
    },
    "4": {
      name: "Uwagi",
      price: "Rp 400.000",
      description: t("equipmentDesc9.4")
    },
    "5": {
      name: "Hakama",
      price: "Rp 470.000",
      description: t("equipmentDesc9.5")
    },
    "6": {
      name: "Sarung/Saya Bokuto PVC",
      price: "Rp 150.000",
      description: t("equipmentDesc9.9")
    },
    "7": {
      name: t("iaitoPlat"),
      price: "Rp 1.000.000",
      description: t("equipmentDesc9.3")
    },
    "8": {
      name: "Habikito",
      price: "Rp 2.200.000",
      description: t("equipmentDesc9.2")
    },
    "9": {
      name: "Shinken",
      price: "Rp 2.300.000",
      description: t("equipmentDesc9.1")
    },
  };

  // State untuk menyimpan item yang dipilih (default: Shinken / "1")
  const [selectedId, setSelectedId] = useState("1");
  const selectedItem = equipmentData[selectedId];

  return (
    <Box display={"flex"} minH={"100vh"} width={"100vw"} background={`transparent url(${background})`}>
      <Helmet>
        <title>{t("equipmentTitleSEO")}</title>
        <meta name="description" content={t("equipmentSEODesc")} />
        <link rel="canonical" href="https://mugairyu-indonesia.com/equipment" />
      </Helmet>
      <Box width={"100vw"}>
        <Menubar />

        {/* Konten Utama */}
        <Box width={"100vw"} px={{ base: "5vw", lg: "20vw" }} pt="20px" pb="60px" display={"flex"} flexDir={"column"} textAlign={"left"}>
          
          {/* Header Halaman */}
          <Box mb={"32px"}>
            <Text textColor={ACCENT_1_COLOR} fontSize={"30px"} className="cormorant-garamond-bold">
              {t("equipmentTitle")}
            </Text>
            <Text textColor={"#765946"} fontSize={"20px"} className="yuji-syuku-regular" mt="1">
              稽古道具一覧
            </Text>
          </Box>

          {/* Bagian 1: Panduan Persyaratan Latihan */}
          <VStack align="flex-start" spacing="4" mb="40px">
            <Text fontSize="15px" lineHeight="1.7">
             {t("equipmentDesc1")}
            </Text>
            
            <Box pl="4" borderLeft={`3px solid ${ACCENT_1_COLOR}`}>
              <Text fontSize="15px" color={PRIMARY_COLOR} fontWeight="bold" className="cormorant-garamond-bold">
                {t("equipmentDesc2")}
              </Text>
              <Text fontSize="14px">{t("equipmentDesc2.1")}</Text>
            </Box>

            <Box pl="4" borderLeft={`3px solid ${ACCENT_1_COLOR}`}>
              <Text fontSize="15px" color={PRIMARY_COLOR} fontWeight="bold" className="cormorant-garamond-bold">
                {t("equipmentDesc3")}
              </Text>
              <Text fontSize="14px">{t("equipmentDesc3.1")}</Text>
            </Box>

            <Box pl="4" borderLeft={`3px solid ${ACCENT_1_COLOR}`}>
              <Text fontSize="15px" color={PRIMARY_COLOR} fontWeight="bold" className="cormorant-garamond-bold">
                {t("equipmentDesc4")}
              </Text>
              <Text fontSize="14px">{t("equipmentDesc4.1")}</Text>
            </Box>

            <Text fontSize="14px" fontStyle="italic" mt="2">
              {t("equipmentDesc5")}
            </Text>
          </VStack>

          <Divider borderColor="rgba(255, 255, 255, 0.1)" mb="40px" />

          {/* Bagian 2: Dropdown Interaktif Pilihan Alat */}
          <Grid templateColumns={{ base: "1fr", md: "1fr 2fr" }} gap="24px" alignItems="start">
            
            {/* Kolom Kiri: Dropdown Pilihan */}
            <GridItem>
              <Text color={PRIMARY_COLOR} fontSize="14px" mb="2" className="cormorant-garamond-bold" letterSpacing="1px">
                {t("equipmentDesc9")}
              </Text>
              <Select
                value={selectedId}
                onChange={(e) => setSelectedId(e.target.value)}
                borderRadius="2px"

              >
                {Object.keys(equipmentData).map((key) => (
                  <option key={key} value={key} >
                    {equipmentData[key].name}
                  </option>
                ))}
              </Select>
            </GridItem>

            {/* Kolom Kanan: Tampilan Detail Dinamis */}
            <GridItem>
              <Box
                bg="rgba(255, 255, 255, 0.03)"
                backdropFilter="blur(8px)"
                border="1px solid rgba(255, 255, 255, 0.08)"
                borderRadius="4px"
                p="6"
                minH="180px"
                display="flex"
                flexDir="column"
                justifyContent="center"
              >
                {selectedItem && (
                  <VStack align="flex-start" spacing="3">
                    <Text fontSize="20px" color={PRIMARY_COLOR} className="cormorant-garamond-bold" fontWeight="bold">
                      {selectedItem.name}
                    </Text>
                    <Text fontSize="18px" color={ACCENT_1_COLOR} fontWeight="bold">
                      {selectedItem.price}
                    </Text>
                    <Text fontSize="14px" lineHeight="1.6" textAlign="justify">
                      {selectedItem.description}
                    </Text>
                  </VStack>
                )}
              </Box>
            </GridItem>
          </Grid>

          {/* Bagian 3: Informasi Pemesanan & Produksi */}
          <Box
            mt="40px"
            p="5"
            bg="rgba(118, 89, 70, 0.05)" // Menggunakan warna #765946 dengan opacity tipis
            border="1px dashed #765946"
            borderRadius="2px"
          >
            <Text fontSize="15px" color="#765946" fontWeight="bold" mb="2" className="cormorant-garamond-bold" letterSpacing="1px">
              {t("equipmentDesc6")}
            </Text>
            <Text fontSize="14px" lineHeight="1.6">
              • <strong>{t("equipmentDesc7")}</strong> {t("equipmentDesc7.1")}<br />
              • <strong>{t("equipmentDesc8")}</strong> {t("equipmentDesc8.1")}
            </Text>
          </Box>

        </Box>
      </Box>
    </Box>
  );
}